const Layout = () => import(/* webpackChunkName: "Layout" */ "../views/Layout.vue");
const MyProfile = () => import(/* webpackChunkName: "Layout" */ "../views/myProfile/Index.vue");
const Order = () => import(/* webpackChunkName: "Layout" */ "../views/myProfile/order/Index.vue");
const OrderDetail = () => import(/* webpackChunkName: "Layout" */ "../views/myProfile/order/ShopOrderInfo.vue");
const HotelOrderDetail = () => import(/* webpackChunkName: "Layout" */ "../views/myProfile/order/HotelOrderInfo.vue");
const AfterSales = () => import(/* webpackChunkName: "Layout" */ "../views/myProfile/afterSales/Index.vue");
const SalesDetail = () => import(/* webpackChunkName: "Layout" */ "../views/myProfile/afterSales/SalesDetail.vue");
const Wallet = () => import(/* webpackChunkName: "Layout" */ "../views/myProfile/wallet/Index.vue");
const Points = () => import(/* webpackChunkName: "Layout" */ "../views/myProfile/points/Index.vue");
const Coupon = () => import(/* webpackChunkName: "Layout" */ "../views/myProfile/coupon/Index.vue");
const Address = () => import(/* webpackChunkName: "Layout" */ "../views/myProfile/address/Index.vue");
const Profile = () => import(/* webpackChunkName: "Layout" */ "../views/myProfile/profile/Index.vue");
const PayWay = () => import(/* webpackChunkName: "Eshop" */ "../views/eshop/PayWay.vue");
const ApplyRefund = () => import(/* webpackChunkName: "Layout" */ "../views/myProfile/afterSales/ApplyRefund.vue");
export default [
  {
    path: "/my-profile",
    component: Layout,
    name: "myProfile",
    hidden: true,
    meta: {
      title: "个人中心",
      titleEn: "My profile",
    },
    children: [
      {
        path: "",
        redirect: "/my-profile/order",
        component: MyProfile,
        name: "myProfile",
        hidden: true,
        meta: {
          title: "个人中心",
          titleEn: "My profile",
        },
        children: [
          {
            path: "order",
            component: Order,
            meta: {
              title: "订单",
              titleEn: "Order",
              auth: true,
            },
          },
          {
            path: "order/hotel-detail",
            component: HotelOrderDetail,
            hidden: true,
            meta: {
              title: "酒店订单详情",
              titleEn: "Hotel Order Detail",
              auth: true,
            },
          },
          {
            path: "order/pay-way",
            component: PayWay,
            hidden: true,
            meta: {
              auth: true
            }
          },
          {
            path: "order/detail",
            component: OrderDetail,
            hidden: true,
            meta: {
              title: "订单详情",
              titleEn: "Order Detail",
              auth: true,
              active:"/my-profile/order"
            },
          },
          {
            path: "order/pay-way",
            component: PayWay,
            hidden: true,
            meta: {
              title: "支付",
              titleEn: "Order",
              auth: true,
            }
          },
          {
            path: "after-sales",
            component: AfterSales,
            meta: {
              title: "售后申请",
              titleEn: "After Sales",
              auth: true,
            },
          },
          {
            path: "after-sales/detail",
            component: SalesDetail,
            hidden: true,
            meta: {
              title: "售后申请详情",
              titleEn: "Sales Detail",
              auth: true,
            },
          },
          {
            path: "order/apply-refund",
            component: ApplyRefund,
            hidden: true,
            meta: {
              title: "申请退款",
              titleEn: "Apply Refund",
              auth: true,
            },
          },
          {
            path: "wallet",
            component: Wallet,
            meta: {
              title: "钱包",
              titleEn: "Wallet",
              auth: true,
            },
          },
          {
            path: "points",
            component: Points,
            meta: {
              title: "积分",
              titleEn: "Points",
              auth: true,
            },
          },
          {
            path: "coupon",
            component: Coupon,
            meta: {
              title: "卡券",
              titleEn: "Coupon",
              auth: true,
            },
          },
          {
            path: "address",
            component: Address,
            meta: {
              title: "地址管理",
              titleEn: "Address",
              auth: true,
            },
          },
          {
            path: "profile",
            component: Profile,
            meta: {
              title: "个人资料",
              titleEn: "Profile",
              auth: true,
            },
          },
        ],
      },
    ],
  },
];
